<template>

    <trax-ui-ajax-data-table 
        :id="id" :titles="titles" :bus="bus" :props="props" :endpoint="endpoint" :endpointParams="endpointParams"
        :cols="cols" :header="header"
        :paging="paging" :page-length="50" :searching="searching"
        order-column="1" order-dir="asc"
        ref="learners"
    ></trax-ui-ajax-data-table>
    
</template>

<script>
    export default {
    
        props: {
            id: { default: 'home-learners' },
            header: { default: 1 },
            paging: { default: 1 },
            searching: { default: 1 },
            facesFolder: {default: app_url},
            facesDefault: {default: 'polaris/img/lib/misc/avatar.jpg'},
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                cols: [
                    {width: '50px'},
                    {},
                    {width: '20px'},
                ],
                titles: [
                    '',
                    'Name',
                    '',
                ],
                props: [
                    {source: this.picture },
                    {source: this.name, order: 'lastname' },
                    {source: this.pinHtml },
                ],
                endpoint: app_url+"polaris/api/front/learners",
                endpointParams: {
                    relations: ['entity', 'subentity'],
                    accessors: ['is_pinned'],
                },
            }
        },
        
        mounted() {
            var that = this
            $('#'+this.id+'-table tbody').on( 'click', '.btn', function() {
                that.pinIt($(this).data('id'));
            });
        },

        methods: {

            picture(learner) {
                var src = learner.avatar ? learner.avatar : this.facesFolder + this.facesDefault;
                var html = '<img src="'+src+'" class="avatar">'
                return this.link(learner, html);
            }, 

            name(learner) {
                var html = learner.lastname + ' ' + learner.firstname;
                var entity = '';
                if (learner.entity) entity = learner.entity.name;
                if (learner.subentity) entity += ' / ' + learner.subentity.name;
                html += '<br><small>'+entity+'</small>';
                return this.link(learner, html);
            },

            link(learner, content) {
                var href = 'ui/atpl-dashboard/learner/'+learner.id;
                return '<a href="'+href+'">'+content+'</a>';
            },

            pinHtml(learner) {
                if (!this.filterPermission) {
                    return ''
                }
                let color = learner.is_pinned ? 'text-primary' : 'text-mutted'
                let html = '<div class="btn btn-link btn-just-icon btn-sm '+color+'" data-id="'+learner.id+'">'
                html += '   <i class="material-icons">location_on</i>'
                html += '</div>'
                return html
            },

            filterPermission() {
                return this.user.admin 
                    || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-all']
                    || this.user.permissions['dashboard.write-mine-locations']
                    || this.user.permissions['dashboard.write-all'];
            },

            pinIt(learnerId) {
                axios.post(
                    this.endpoint + '/' + learnerId + '/pin',
                )
                .then(response => {
                    this.$refs.learners.refresh();
                })
                .catch(error => {
                    this.$auth.handleErrorVm(error, this)
                })
            },
        }
    }
</script>
